import { css, FlattenSimpleInterpolation } from 'styled-components';

import { FontWeight } from '../enums/fontWeight.enum';

export const MarkdownStyles: FlattenSimpleInterpolation = css`
  strong {
    font-weight: ${FontWeight.Bold};
  }
`;
